import { ListItemButton } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import colorConfigs from "../../configs/colorConfigs";
import { RootState } from "../../redux/store";
import { RouteType } from "../../routes/config";
import useAccessControl from "../hooks/useAccessControl";
import Cookies from "js-cookie";
import { useTheme } from "../hooks/useTheme";

type Props = {
  item: RouteType
};

const SidebarItem = ({ item }: Props) => {
  const { themeStyles } = useTheme();
  const { appState } = useSelector((state: RootState) => state.appState);
  const { permissions }: any = useAccessControl();
  const role = Cookies.get("role-jj-rental-ui") || '';

  return (
    item.sidebarProps && item.path && (role.toLowerCase() === "admin" || permissions[item.section || '']) ? (
      <ListItemButton
        component={Link}
        to={item.path}
        className="w-full flex p-[10px] items-center gap-2.5"
        sx={{
          "&: hover": {
            backgroundColor: appState === item.state ? colorConfigs.sidebar.activeBg : themeStyles.sideBar.menuItemsHoverColor
          },
          backgroundColor: appState === item.state ? colorConfigs.sidebar.activeBg : "unset",
          color: appState === item.state ? "#167AC3" : themeStyles.sideBar.menuItemsColor,
          padding: "10px 10px 10px 45px",
          borderRight: appState === item.state ? "6px solid #167AC3" : "unset",
        }}
      >

        <span className={` ${appState === item.state ? 'text-[#167AC3]' : themeStyles.sideBar.tailwindMenuItemsColor} text-[13px] font-medium tracking-wide`}>
          {item.sidebarProps.displayText}
        </span>
      </ListItemButton>
    ) : null
  );
};

export default SidebarItem;